import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";

import { ICellEditorAngularComp } from "ag-grid-angular";

@Component({
    selector: 'checkbox-cell',
    templateUrl: 'g-checkbox-editor.component.html'
})
export class AGCheckBoxEditorComponent implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: boolean;

    @ViewChild('checkbox') public input: ElementRef<HTMLInputElement>;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value;
    }

    getValue(): any {
        return this.value;
    }

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            this.input.nativeElement.focus();
        })
    }
}